import React from "react";
import {
  Box,
  Select,
  MenuItem,
  SvgIcon,
  Typography,
  CircularProgress,
} from "@mui/material";
import { ReactComponent as DropArrowIcon } from "../../../Icons/SelectDropdownArrow.svg";
import {
  TypoGraph,
  StyledSecondaryServiceTypography,
  StyledSecondaryTypography,
} from "../../../Theme";
import { ReactComponent as ActiveIcon } from "../../../Icons/ActiveGraph.svg";
import { ReactComponent as InactiveIcon } from "../../../Icons/InactiveIcon.svg";
import { ReactComponent as OffBoardIcon } from "../../../Icons/OffBoardIcon.svg";
import Chart from "react-apexcharts";
import { ReactComponent as ExclamatoryIcon } from "../../../Icons/GraphExclamatoryIcon.svg";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Indicator from "../../../Icons/tooltipIndicator.svg";

const ServiceRequestGraph = () => {
  const { ServiceRequestData, OverviewStatus } = useSelector(
    (state) => state.OverView
  );
  const { LanguageData } = useSelector((state) => state.Language);
  const ServiceRequestseries = [
    {
      name: "Submitted",
      data: [
        ServiceRequestData?.jan?.submitted || 0,
        ServiceRequestData?.feb?.submitted || 0,
        ServiceRequestData?.mar?.submitted || 0,
        ServiceRequestData?.apr?.submitted || 0,
        ServiceRequestData?.may?.submitted || 0,
        ServiceRequestData?.jun?.submitted || 0,
        ServiceRequestData?.jul?.submitted || 0,
        ServiceRequestData?.aug?.submitted || 0,
        ServiceRequestData?.sep?.submitted || 0,
        ServiceRequestData?.oct?.submitted || 0,
        ServiceRequestData?.nov?.submitted || 0,
        ServiceRequestData?.dec?.submitted || 0,
      ],
    },
    {
      name: "Approved",
      data: [
        ServiceRequestData?.jan?.approved || 0,
        ServiceRequestData?.feb?.approved || 0,
        ServiceRequestData?.mar?.approved || 0,
        ServiceRequestData?.apr?.approved || 0,
        ServiceRequestData?.may?.approved || 0,
        ServiceRequestData?.jun?.approved || 0,
        ServiceRequestData?.jul?.approved || 0,
        ServiceRequestData?.aug?.approved || 0,
        ServiceRequestData?.sep?.approved || 0,
        ServiceRequestData?.oct?.approved || 0,
        ServiceRequestData?.nov?.approved || 0,
        ServiceRequestData?.dec?.approved || 0,
      ],
    },
    {
      name: "Cancelled",
      data: [
        ServiceRequestData?.jan?.cancelled || 0,
        ServiceRequestData?.feb?.cancelled || 0,
        ServiceRequestData?.mar?.cancelled || 0,
        ServiceRequestData?.apr?.cancelled || 0,
        ServiceRequestData?.may?.cancelled || 0,
        ServiceRequestData?.jun?.cancelled || 0,
        ServiceRequestData?.jul?.cancelled || 0,
        ServiceRequestData?.aug?.cancelled || 0,
        ServiceRequestData?.sep?.cancelled || 0,
        ServiceRequestData?.oct?.cancelled || 0,
        ServiceRequestData?.nov?.cancelled || 0,
        ServiceRequestData?.dec?.cancelled || 0,
      ],
    },
  ];
  const options = {
    chart: {
      type: "bar",
      cursor: "pointer",
      events: {
        mouseMove: (event, chartContext) => {
          chartContext.el.style.cursor = "pointer";
        },
        mouseLeave: (event, chartContext) => {
          chartContext.el.style.cursor = "default";
        },
      },
      stacked: true,
      toolbar: {
        show: false,
      },
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      labels: {
        style: {
          fontSize: "12px",
          fontFamily: "Inter, sans-serif",
          color: "#384250",
          fontWeight: 400,
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return value;
        },
        style: {
          fontSize: "12px",
          fontFamily: "Inter, sans-serif",
          color: "#384250",
          fontWeight: 400,
        },
      },
    },
    colors: ["#1687BD", "#FF7C32", "#9A66FF"],
    legend: {
      show: false,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        cursor: "pointer",
        columnWidth: "50%",
        // borderRadius: 8,
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      theme: false,
      style: {
        background: "#262D33",
      },
      x: {
        show: false,
      },
      y: {
        title: {
          formatter: function () {
            return "";
          },
        },
      },
      marker: {
        show: false,
      },
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        const total =
          series[0][dataPointIndex] +
          series[1][dataPointIndex] +
          series[2][dataPointIndex];
        const active = series[0][dataPointIndex];
        const inactive = series[1][dataPointIndex];
        const offboard = series[2][dataPointIndex];
        const month = w.globals.labels[dataPointIndex];

        return `
        <div class="background">
        <div class="triangle">
       
       <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 16V0L1.5 6.5L0.5 7.5L0 8L8 16Z" fill="#262D35"/>
</svg>
       
        </div>

            <div class="apexcharts-tooltip-custom">
              <div class="total-count-tip">
              <div>
              Total
              </div> 
              <div>
              ${total} 
              </div>
              </div>
              <div class="tool-tip-parent">
              <div><svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
              <rect x="0.490234" y="0.305664" width="8" height="8" rx="2" fill="#1687BD"/>
              </svg>
              Submitted
              </div>
              <div>
              ${active}
              </div>
            </div>
              <div class="tool-tip-parent">
              <div>
               <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
              <rect x="0.490234" y="0.305664" width="8" height="8" rx="2" fill="#FF7C32"/>
              </svg>
              Approved
              </div> 
              <div>
               ${inactive}
               </div>
              </div>
              <div class="tool-tip-parent">
              <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
              <rect x="0.490234" y="0.305664" width="8" height="8" rx="2" fill="#9A66FF"/>
              </svg>
              Cancelled
              </div>
              <div>${offboard}</div>
              </div>
              <div class="month-change-top">${month}${" "}${2023}</div>
            </div>
            </div>
          `;
      },
    },
    states: {
      normal: {
        filter: {
          type: "none",
          value: 0,
        },
      },
      hover: {
        filter: {
          type: "none",
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: "none",
          value: 0,
        },
      },
    },
    
  };

  return (
    <>
      {
        <>
          <Box
            sx={{
              borderBottom: "1px solid #E5E7EB",
              borderTop: "1px solid #E5E7EB",
              padding: "16px",
              backgroundColor: "#FCFCFD",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Box>
                <StyledSecondaryServiceTypography style={{ fontWeight: 500 }}>
                  {`${
                    LanguageData?.home_total_request || "Total Requests"
                  }${" "}${ServiceRequestData?.total_count || 0} `}
                </StyledSecondaryServiceTypography>
              </Box>
            </Box>
            <Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    marginRight: "20px",
                    alignItems: "center",
                  }}
                >
                  <ActiveIcon style={{ marginRight: "10px" }} />
                  <TypoGraph>
                    {LanguageData?.home_submit || "Submitted"}
                  </TypoGraph>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    marginRight: "20px",
                  }}
                >
                  <InactiveIcon style={{ marginRight: "10px" }} />
                  <TypoGraph>
                    {LanguageData?.home_approved || "Approved"}
                  </TypoGraph>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <OffBoardIcon style={{ marginRight: "10px" }} />
                  <TypoGraph>
                    {LanguageData?.home_cancel || "Cancelled"}
                  </TypoGraph>
                </Box>
              </Box>
            </Box>
          </Box>
          {ServiceRequestData.total_count ? (
            <Box
              sx={{
                borderRadius: "0px 0px 8px 8px",
                backgroundColor: "#FFFFFF",
              }}
            >
              <Chart
                options={options}
                series={ServiceRequestseries}
                type="bar"
                height={400}
              />
            </Box>
          ) : (
            <Box
              sx={{
                borderRadius: "0px, 0px, 8px, 8px",
                padding: "16px",
                backgroundColor: "#F9FAFB",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "300px",
              }}
            >
              {OverviewStatus ? (
                <CircularProgress />
              ) : (
                <>
                  {" "}
                  <ExclamatoryIcon
                    style={{ marginBottom: "5px", marginTop: "60px" }}
                  />
                  <Typography
                    sx={{
                      color: "#9DA4AE",
                      fontSize: "16px",
                      fontWeight: 600,
                      width: "470px",
                      my: 2,
                      textAlign: "center",
                      marginTop: "5px",
                    }}
                    style={{ color: "#4D5761" }}
                  >
                    No statistics available for display
                  </Typography>
                  <StyledSecondaryTypography
                    color="#9DA4AE !important"
                    textAlign="center"
                    width="400px"
                    height="88px"
                    fontSize="16px"
                    fontWeight="400px"
                    lineHeight="22.4px"
                    marginBottom="60px"
                  >
                    To get started, you can{" "}
                    <Link to="/documentations" style={{ color: "#0E4965" }}>
                      <b>click here </b>
                    </Link>{" "}
                    to add terms&condition via property documentations in the
                    setting page.
                  </StyledSecondaryTypography>
                </>
              )}
            </Box>
          )}
        </>
      }
    </>
  );
};

export default ServiceRequestGraph;
